__turbopack_context__.v({
  "addMoreButton": "FileUpload-module__wCMhgW__addMoreButton",
  "addMoreText": "FileUpload-module__wCMhgW__addMoreText",
  "addMoreWrapper": "FileUpload-module__wCMhgW__addMoreWrapper",
  "container": "FileUpload-module__wCMhgW__container",
  "container__disabled": "FileUpload-module__wCMhgW__container__disabled",
  "container__dragOver": "FileUpload-module__wCMhgW__container__dragOver",
  "container__error": "FileUpload-module__wCMhgW__container__error",
  "container_withFiles": "FileUpload-module__wCMhgW__container_withFiles",
  "content": "FileUpload-module__wCMhgW__content",
  "hiddenInput": "FileUpload-module__wCMhgW__hiddenInput",
  "icon": "FileUpload-module__wCMhgW__icon",
  "label": "FileUpload-module__wCMhgW__label",
  "message": "FileUpload-module__wCMhgW__message",
  "message__error": "FileUpload-module__wCMhgW__message__error",
  "primaryText": "FileUpload-module__wCMhgW__primaryText",
  "pulse": "FileUpload-module__wCMhgW__pulse",
  "removeButton": "FileUpload-module__wCMhgW__removeButton",
  "secondaryText": "FileUpload-module__wCMhgW__secondaryText",
  "text": "FileUpload-module__wCMhgW__text",
  "thumbnail": "FileUpload-module__wCMhgW__thumbnail",
  "thumbnailWrapper": "FileUpload-module__wCMhgW__thumbnailWrapper",
  "thumbnailsContainer": "FileUpload-module__wCMhgW__thumbnailsContainer",
  "uploadPrompt": "FileUpload-module__wCMhgW__uploadPrompt",
  "wrapper": "FileUpload-module__wCMhgW__wrapper",
});
